module.exports = __webpack_public_path__ + "img/fleetAvantar.96ffb880.png";